import TermsOfService from "./TermsOfService";

export const routes = [
    {
        path: "/terms-of-service",
        component: TermsOfService,
        exact: true,
        showNav: true
    }
]